import React, { useState } from 'react';
import { Col, Form, Table } from 'react-bootstrap';
import { Button, DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import { t } from 'i18next';
import { ChangeHighlighter } from '@rd-web-markets/shared/dist/util/ChangeHighlighter';
import FinancialYear from './FinancialYear';
import UploadDocumentsModal from './UploadDocumentsModal';
import './tableScroll.css';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
const ContractorFinancialDetailsForm = _ref => {
  let {
    handleDeleteDetail,
    loading,
    contractor,
    handleCreateDetail,
    handleFinancialDetailChange,
    saveFinancialDetailChange,
    saveFinancialYearChange,
    addFile,
    removeAttachment,
    setSelectedContractor,
    applicationSubmitted
  } = _ref;
  const [showModal, setShowModal] = useState(false);
  const sortFinancialDetails = financialDetails => {
    return financialDetails.sort((a, b) => {
      if (a.cost_type === 'estimate') {
        return -1;
      } else {
        return 1;
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UploadDocumentsModal, {
    showModal: showModal,
    setShowModal: setShowModal,
    handleSubmit: addFile,
    financialDetails: sortFinancialDetails(contractor.financial_details)
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'scroll'
    }
  }, /*#__PURE__*/React.createElement(Table, {
    size: "md"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("tr", {
    key: "tr1",
    className: "break-text"
  }, /*#__PURE__*/React.createElement("th", {
    key: "tr1th2",
    className: "text-center",
    style: {
      minWidth: '170px'
    }
  }, contractor.contractor_type === 'bfsz' && /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleCreateDetail('estimate'),
    style: {
      marginTop: '0.25rem',
      marginBottom: '0.25rem'
    },
    type: "primary",
    icon: /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "add"),
    loading: loading,
    disabled: applicationSubmitted
  }, t('add_estimate')), /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleCreateDetail('offer'),
    style: {
      marginTop: '0.25rem',
      marginBottom: '0.25rem'
    },
    type: "primary",
    className: "mx-2",
    icon: /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "add"),
    disabled: applicationSubmitted,
    loading: loading
  }, t('add_offer'))), /*#__PURE__*/React.createElement("th", {
    key: "tr1th1"
  }, t('project_total')), contractor.years.map((year, index) => {
    return /*#__PURE__*/React.createElement("th", {
      key: `tr1th${year}`,
      className: "contractor-years"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between"
    }, /*#__PURE__*/React.createElement("div", null, year), /*#__PURE__*/React.createElement("div", null, t('total'), /*#__PURE__*/React.createElement(ChangeHighlighter, {
      as: FormattedNumberInput,
      thousandSeparator: ".",
      decimalSeparator: ",",
      onBlur: saveFinancialYearChange,
      object: {
        yearsTotal: contractor.years_total[index]
      },
      name: "yearsTotal",
      type: "text",
      size: "sm",
      className: "me-4",
      disabled: true
    }))));
  }), /*#__PURE__*/React.createElement("th", {
    key: "tr1th3",
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setShowModal(true),
    type: "primary",
    className: "mx-2",
    icon: /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "file_upload"),
    disabled: applicationSubmitted,
    loading: loading
  }, t('upload_file')))), /*#__PURE__*/React.createElement("tr", {
    key: "tr2"
  }, /*#__PURE__*/React.createElement("th", {
    key: "tr2th1"
  }), contractor.years.map(year => /*#__PURE__*/React.createElement("th", {
    key: 'tr2' + year
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-weight-light text-end"
  }, t('include_in_total')))), /*#__PURE__*/React.createElement("th", {
    key: "tr2th2"
  }, t('comments')), /*#__PURE__*/React.createElement("th", {
    key: "tr2th3"
  }, t('uploaded')))), /*#__PURE__*/React.createElement("tbody", null, sortFinancialDetails(contractor.financial_details).map((detail, index) => /*#__PURE__*/React.createElement("tr", {
    key: `tr${index}`
  }, /*#__PURE__*/React.createElement("td", {
    key: `tr${index}td1`
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 8
    }
  }, detail.cost_type, " ", contractor.financial_details.filter(fd => fd.cost_type === detail.cost_type).findIndex(fd => fd.id === detail.id) + 1), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 4
    }
  }, /*#__PURE__*/React.createElement(DeleteButton, {
    variant: "danger",
    size: "sm",
    className: "text-white ms-3",
    disabled: applicationSubmitted,
    onClick: () => handleDeleteDetail(detail.id)
  })))), detail.financial_years.map(financialYear => {
    return /*#__PURE__*/React.createElement("td", {
      key: `tr${index}td${financialYear.year}`,
      className: detail.cost_type === 'offer' ? 'contractor-years' : ''
    }, /*#__PURE__*/React.createElement(FinancialYear, {
      applicationSubmitted: applicationSubmitted,
      setSelectedContractor: setSelectedContractor,
      contractor: contractor,
      saveFinancialYearChange: saveFinancialYearChange,
      financialYear: financialYear,
      detail: detail,
      loading: loading
    }));
  }), /*#__PURE__*/React.createElement("td", {
    key: `tr${index}td2`
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: e => handleFinancialDetailChange(e, detail.id),
    onBlur: () => saveFinancialDetailChange(detail),
    object: detail,
    name: "comments",
    controlAs: "textarea",
    rows: "3",
    disabled: applicationSubmitted
  })), /*#__PURE__*/React.createElement("td", {
    key: `tr${index}td3`
  }, detail.download_links.map((attachment, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex",
      key: index
    }, /*#__PURE__*/React.createElement(Col, {
      md: {
        span: 2
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "attachment")), /*#__PURE__*/React.createElement(Col, {
      md: {
        span: 7
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: attachment.url,
      target: "_blank",
      rel: "noreferrer"
    }, attachment.filename)), /*#__PURE__*/React.createElement(Col, {
      md: {
        span: 2
      }
    }, /*#__PURE__*/React.createElement(DeleteButton, {
      variant: "danger",
      size: "sm",
      className: "text-white ms-3",
      onClick: () => removeAttachment(detail, attachment.id)
    })));
  }))))))));
};
export default ContractorFinancialDetailsForm;